import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MomMinutesOfMeetingService } from 'src/app/services/mom-minutes-of-meeting.service';

@Component({
  selector: 'app-mom-record-meeting',
  templateUrl: './mom-record-meeting.component.html',
  styleUrls: ['./mom-record-meeting.component.css']
})
export class MomRecordMeetingComponent implements OnInit {

  @ViewChild('attendenceAlertDialog') attendenceAlertDialog!: TemplateRef<any>
  @ViewChild('dateTimeErrorDialog') dateTimeErrorDialog!: TemplateRef<any>
  @ViewChild('aF') aF!: ElementRef;
  @ViewChild('aT') aT!: ElementRef;

  description:any = "<p><b>Lorem ipsum</b> dolor sit amet, <s>consectetur adipiscing elit</s>, sed do eiusmod tempor <u>incididunt</u> ut labore et dolore <i>magna aliqua</i>.";

  createMeetingForm!: FormGroup
  userForm!:FormGroup
  actionPointsForm:FormGroup;
  meetingMinutesForm:FormGroup;

  mode:any
  agendaMode:string = 'add'
  lotteryList:any = []
  boardList:any = []
  meetingTypeList:any = []
  meetingList:any = []
  meetingId:number = 0
  userId:number = 0

  userArr:any = []
  usersList:any = []
  medialist:any = []
  fileList: File[] = [];
  listOfFiles: File[] = [];
  actionPoints:any = []
  meetingUserList:any

  agendaId:number = 0
  action:string = 'save'
  agendaDescription:any
  meetingMinutesDescription:any
  dateTime:any
  endTime:any
  startTime:any;
  index:number = 0
  addDescription:boolean = false
  meetingMinutes:any = []
  mediaUrl: string = '';

  constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private router: Router,
    private momMinutesOfMeetingService: MomMinutesOfMeetingService, private dialog: MatDialog) {

      this.activatedRoute.params.subscribe((res:any)=>{
        this.mode = res.mode,
        this.meetingId = res.id
        console.log("MODE", this.mode)
      })

      this.userId = Number(sessionStorage.getItem('userId'))
      
      this.createMeetingForm = this.formBuilder.group({
        id: '',
        login: [''],
        meetingName: ['', [Validators.required]],
        mode: ['', [Validators.required]],
        board: new FormGroup({
          id: new FormControl('', Validators.required),
          boardName: new FormControl(''),
        }),

        lottery: new FormGroup({
          id: new FormControl('', Validators.required),
          lotteryName: new FormControl(''),
          board: new FormControl({})
        }),

        meetingType: new FormGroup({
          id: new FormControl('', Validators.required),
          meetingType: new FormControl(''),
        }),

        dateTime: ['', [Validators.required]],
        location: ['', [Validators.required]],
        media: [[]],
        status: ['PENDING', [Validators.required]],
        meetingAgenda: [''],
        meetingLink: ["", [Validators.required]],
        startTime:  ["", [Validators.required]],
        endTime:  ["",[Validators.required]],
        isArchived:false,
        meetingCreatedBy: [this.userId, [Validators.required]],
        meetingUsers: '',
        notes: '',
        meetingMinutes:[[]],
        actionPoint:[[]]
      })

      this.actionPointsForm = this.formBuilder.group({
        assignedTo: '',
        actionPoint: ''
      })

      this.meetingMinutesForm = this.formBuilder.group({
        name: '',
        discription: ''
      })
  }

  ngOnInit() {
    if(this.mode == 'edit' || this.mode == 'record'){
      this.getMeetingById(this.meetingId)
    }else if(this.mode = 'approval'){
      this.approvalMeetingById(this.meetingId)
    }

    // this.createMeetingForm.statusChanges.subscribe((status) => {
    //   console.log("________________", status == 'VALID')
      
    //   for (const controlName in this.createMeetingForm.controls) {
    //     if (this.createMeetingForm.controls.hasOwnProperty(controlName)) {
    //       const control = this.createMeetingForm.get(controlName);
    //       // Do something with the control, e.g., access its value or update it
    //       console.log(controlName, control?.valid);
    //     }
    //   }
    // })

  }

  getMeetingById(id:number){
    this.momMinutesOfMeetingService.getMeetingsById(id)
    .subscribe((res:any)=>{
      this.meetingList = res
      this.createMeetingForm.patchValue({
        ...res,
        board: {
          id: res?.board?.key,
          boardName: res?.board.boardName
        },
        lottery: {
          id: res?.lottery?.key,
          lotteryName: res?.lottery?.lotteryName
        }
      })
      this.usersList = res.meetingUsers
      this.medialist = res.media
      this.mediaUrl = res.mediaUrl + '/open/mom-media';
      // this.startTime = res.startTime ? res.startTime : sessionStorage.getItem('startTime')
      // this.endTime = res.endTime
      this.dateTime = new Date(res.dateTime).toString()
      // this.endTime = new Date(this.startTime).toISOString()
      // this.endTime.setMinutes(this.endTime.getMinutes() + 30)
      // this.endTime.setMinutes(this.endTime)
      // console.log("Endtime", this.endTime)
      // this.endTime = res.endTime
    })
  }

  approvalMeetingById(id:number){
    this.momMinutesOfMeetingService.getMeetingsById(id)
    .subscribe((res:any)=>{
      this.meetingList = res
      console.log(res)
      this.createMeetingForm.patchValue(res)
      this.usersList = res.meetingUsers;
      this.actionPoints = res.actionPoint
      this.meetingMinutes = res.meetingMinutes
      this.startTime = res.startTime
      this.endTime = res.endTime
      this.dateTime = new Date(res.dateTime).toString()
    })
  }

  dateTimeErrorMsg:string = ''
  setStartTime(d:any){
    if(new Date(this.createMeetingForm.value.dateTime).toString() < new Date(d).toString()){
      this.startTime = new Date(d).toString()
      this.createMeetingForm.value.startTime = new Date(d).toString()
    }else{
      this.dateTimeErrorMsg = 'Selected start date & time should be greater than meeting date & time.'
      this.createMeetingForm.patchValue({
        'startTime': ''
      })
      this.dialog.open(this.dateTimeErrorDialog, {
        width: '35%',
        height: '15%'
      })
    }
  }

  setEndTime(d:any){
    if(new Date(this.createMeetingForm.value.startTime).toISOString() < new Date(d).toISOString()){
      this.endTime = new Date(d).toISOString()
      this.createMeetingForm.value.startTime = new Date(d).toISOString()
    }else{
      this.dateTimeErrorMsg = 'Selected end date & time should be greater than start date & time.'
      this.createMeetingForm.patchValue({
        'endTime': ''
      })
      this.dialog.open(this.dateTimeErrorDialog, {
        width: '35%',
        height: '15%'
      })
    }
    this.endTime = new Date(d).toString()
    this.createMeetingForm.value.endTime = new Date(d).toString()
  }

  meetingMinutesMode:string = 'add'
  meetingMinutesIndex:string = ''
  addMinutesDescription(){
    // if(this.agendaMode == 'add'){
    //   console.log("Adding")

    //   this.meetingMinutes.push({name:this.createMeetingForm.value.meetingMinutes, description: ''})
    //   this.createMeetingForm.patchValue({
    //     meetingMinutes: ''
    //   })
    // }else if(this.agendaMode == 'edit'){
    //   this.meetingMinutes[this.agendaId].name =  this.createMeetingForm.value.meetingMinutes
    //   this.createMeetingForm.patchValue({
    //     meetingMinutes: ''
    //   })
    // }

    if(this.meetingMinutesMode == 'add'){
      console.log("Adding", this.meetingMinutesForm.value)
      this.meetingMinutes.push(this.meetingMinutesForm.value)
      this.meetingMinutesForm.reset()
    }else if(this.meetingMinutesMode == 'edit'){
      this.meetingMinutes[this.meetingMinutesIndex] =  this.meetingMinutesForm.value
      this.meetingMinutesForm.reset()
    }
    this.meetingMinutesMode = 'add'
  }

  editMeetingMinutes(index:any, mode:string){
    // this.agendaMode = mode
    // this.agendaId = index
    // this.createMeetingForm.patchValue({
    //   meetingMinutes: this.meetingMinutes[index].name
    // })

    console.log("Point", index, this.actionPoints[index])
    this.meetingMinutesMode = mode
    this.meetingMinutesIndex = index
    this.meetingMinutesForm.patchValue({
      name: this.meetingMinutes[index].name,
      discription: this.meetingMinutes[index].discription
    })
  }

  removeMeetingMinutes(index:number) {
    this.meetingMinutes.splice(index, 1);
  }


  actionPointsMode:string = 'add'
  actionPointsIndex:string = ''
  addActionPoints(){
    if(this.actionPointsMode == 'add'){
      console.log("Adding", this.actionPointsForm.value)
      this.actionPoints.push(this.actionPointsForm.value)
      this.actionPointsForm.reset()
    }else if(this.actionPointsMode == 'edit'){
      this.actionPoints[this.actionPointsIndex] =  this.actionPointsForm.value
      this.actionPointsForm.reset()
    }
    this.actionPointsMode = 'add'
    console.log("actionPoint", this.actionPoints)
  }

  editActionPoints(index:any, mode:string){
    console.log("Point", index, this.actionPoints[index])
    this.actionPointsMode = mode
    this.actionPointsIndex = index
    this.actionPointsForm.patchValue({
      assignedTo: this.actionPoints[index].assignedTo,
      actionPoint: this.actionPoints[index].actionPoint
    })
  }

  removeActionPoints(index:number) {
    this.actionPoints.splice(index, 1);
  }


  saveRecording(){
    console.log(this.createMeetingForm);
    console.log(this.createMeetingForm.value);

    if(!this.createMeetingForm.invalid) {
      this.createMeetingForm.value.status = 'PENDING'
      this.createMeetingForm.value.startTime = new Date(this.startTime).toISOString()
      this.createMeetingForm.value.endTime = new Date(this.endTime).toISOString()
      this.createMeetingForm.value.meetingMinutes = this.meetingMinutes
      this.createMeetingForm.value.actionPoint = this.actionPoints
      this.createMeetingForm.value.meetingMinutes = this.meetingMinutes
      console.log("this.createMeetingForm", this.createMeetingForm.value)
  
      if(this.meetingList.status == "SCHEDULED"){
        if(this.checkAttendence(this.createMeetingForm.value.meetingUsers)){
          this.momMinutesOfMeetingService.updateRecordMeeting(this.createMeetingForm.value) //putMethod('updateRecordMeeting', this.createMeetingForm.value)
          .subscribe((res:any)=>{
            console.log("Successfull")
            this.goBack()
          }, error => {
            this.momMinutesOfMeetingService.errorToast(error.errorMessage||error.error.message);
          })
        }else{
          this.dialog.open(this.attendenceAlertDialog, {
            width: '35%',
            height: '120px'
          })
        }
      }
    }
    else {
      this.momMinutesOfMeetingService.errorToast('Please enter mandatory fields.');
    }
  }


  goToApprove(){
    this.router.navigate(['/secure/mom-approve-meeting'])
  }

  approveMeeting(){
   
    const element = document.getElementById('pdfView')!;    
    

    for (const user of this.meetingList.meetingUsers) {
      if (user.userId == +localStorage.getItem("userId")) {
        user.isApproved = true;
        break
      }
    }
    let body = {
      meeting: this.meetingList,
      htmlContent: element.outerHTML
    }

    this.momMinutesOfMeetingService.meetingApprovedWithPDF(body)//putMethod('meetingApprovedWithPDF', body)
    .subscribe((res:any)=>{
      console.log("Successfull")
      this.goToApprove()
    })
  }

  addCorrection(notes:any){
    // this.meetingList.meetingUsers[0].notes = "notes"

    for (const user of this.meetingList.meetingUsers) {
      if (user.userId == Number(sessionStorage.getItem('userId'))) {
        user.notes = notes;
        break
      }
    }

    console.log(this.meetingList.meetingUsers)
    this.momMinutesOfMeetingService.updateCorrectionMeeting(this.meetingList.id, notes)//putMethod('updateCorrectionMeeting', this.meetingList)
    .subscribe((res:any)=>{
      console.log("Successfull")
      this.goToApprove()
      this.dialog.closeAll()
    })
  }

  openDialog(openNotesDialog: TemplateRef<any>){
    this.dialog.open(openNotesDialog, {
      minWidth: '30%',
    })
  }

  setAttendence(index:number, user:any){
    user.isAttended = !user.isAttended
  }

  checkAttendence(users:any){
    for (const user of users) {
      if (user.isAttended === true) {
        return true;
      }
    }
    return false;
  }

  cancelMeeting(){
    console.log(this.createMeetingForm.value, this.startTime, this.endTime)
    this.createMeetingForm.value.status = 'CANCELLED'
    // this.createMeetingForm.value.startTime = new Date(this.startTime).toISOString()
    // this.createMeetingForm.value.endTime = new Date(this.endTime).toISOString()
    this.createMeetingForm.value.meetingMinutes = this.meetingMinutes
    this.createMeetingForm.value.actionPoint = this.actionPoints
    console.log("this.createMeetingForm", this.createMeetingForm.value)

    if(this.meetingList.status == "SCHEDULED"){
      this.momMinutesOfMeetingService.updateMeeting(this.createMeetingForm.value)//putMethod('meetings', this.createMeetingForm.value)
      .subscribe((res:any)=>{
        console.log("Successfull")
        this.goBack()
      })
      this.dialog.closeAll()
    }

  }

  goToMeetingLogs(){
    this.router.navigate(['/secure/mom-meeting/meeting-logs/logs'])
  }

  goBack(){
    this.router.navigate(['/secure/mom-start-meeting'])
  }

}
